module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/preloader/index.js
// module id = 173
// module chunks = 1